export enum LegacyElectricalPositionType {
  ROOM_EDGE = "ROOM_EDGE",
  REF_GEOM = "REF_GEOM",
  PROP = "PROP",
}

export enum LegacyRoomEdgePositionType {
  ON_EDGE = "ON_EDGE",
  EDGE_OFFSET = "EDGE_OFFSET",
  CENTER_LINE = "CENTER_LINE",
}

export enum LegacyPropPositionType {
  AT_PROP = "AT_PROP",
  OFFSET_FROM_PROP_BACK = "OFFSET_FROM_PROP_BACK",
  ROOM_WIDTH_PARAM_AT_PROP_AXIS = "ROOM_WIDTH_PARAM_AT_PROP_AXIS",
}
